import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

interface ProfileSummaryProps {
  summary?: string;
}

export default function ProfileSummary({ summary }: ProfileSummaryProps) {
  if (!summary) return null;

  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Summary
        </Typography>
        <Typography variant="body2" paragraph>
          {summary}
        </Typography>
      </CardContent>
    </Card>
  );
}